// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide-folder-icon[data-v-3bf39696]{font-size:20px;line-height:20px;margin-left:5px;margin-right:5px}.media-folders-folder[data-v-3bf39696]{background-color:white;border-radius:5px;padding:5px;border:solid 2px #00b3ee;cursor:pointer;margin-left:10px;margin-bottom:5px}.media-folders-folder__icon[data-v-3bf39696]{color:#00b3ee;font-size:18px}.media-folders-folder__name[data-v-3bf39696]{font-size:18px}\n", ""]);
// Exports
module.exports = exports;
